// Tải file cho trình xem của Hub qua fileProxy (L27, L25, L10).
// - Gửi kèm phiên đăng nhập (vé "token" chỉ mở được bởi đúng người, trong Hub) → chép link ra tab khác không mở được.
// - Máy chủ khởi động nguội đôi khi trả 503: tự thử lại ngay, không bắt người dùng bấm lại.
// - Báo % thật theo số byte đã nhận.
import { auth } from "./firebase";

export class FetchFail extends Error { constructor(public status: number, msg: string) { super(msg); } }

const RETRY = [400, 1200, 2500];
const wait = (ms: number) => new Promise((r) => setTimeout(r, ms));

export async function fetchFile(url: string, opts: { withAuth: boolean; onProgress?: (p: number) => void; signal?: AbortSignal }): Promise<Blob> {
  let last: unknown = null;
  for (let attempt = 0; attempt <= RETRY.length; attempt++) {
    if (attempt) await wait(RETRY[attempt - 1]);
    try {
      const headers: Record<string, string> = {};
      if (opts.withAuth && auth.currentUser) headers.Authorization = `Bearer ${await auth.currentUser.getIdToken()}`;
      const res = await fetch(url, { headers, signal: opts.signal, cache: "no-store" });
      if (res.status >= 500 || res.status === 429) { last = new FetchFail(res.status, await res.text().catch(() => "")); continue; }
      if (!res.ok) throw new FetchFail(res.status, (await res.text().catch(() => "")) || "Không mở được file.");
      // Phản hồi lớn truyền dạng chunked (không có Content-Length) → dùng X-Total-Length của Hub để báo % thật (L10)
      const total = Number(res.headers.get("content-length") || res.headers.get("x-total-length") || 0);
      if (!res.body || !total || !opts.onProgress) return await res.blob();
      const reader = res.body.getReader();
      const parts: Uint8Array[] = [];
      let got = 0;
      for (;;) {
        const { done, value } = await reader.read();
        if (done) break;
        parts.push(value); got += value.length;
        opts.onProgress(Math.min(1, got / total));
      }
      return new Blob(parts as BlobPart[], { type: res.headers.get("content-type") ?? "" });
    } catch (e) {
      if (e instanceof FetchFail || (e as Error).name === "AbortError") throw e;
      last = e;   // lỗi mạng chập chờn → thử lại
    }
  }
  throw last instanceof FetchFail ? new FetchFail(last.status, "Máy chủ đang bận, vui lòng thử lại.") : last;
}

/** Tải về: gọi thử HEAD (đánh thức máy chủ, thử lại khi 503) rồi mới chuyển trình duyệt sang link tải. */
export async function startDownload(url: string) {
  if (/cloudfunctions\.net|127\.0\.0\.1:5001/.test(url)) {
    for (let attempt = 0; attempt <= RETRY.length; attempt++) {
      if (attempt) await wait(RETRY[attempt - 1]);
      const r = await fetch(url, { method: "HEAD", cache: "no-store" }).catch(() => null);
      if (r && r.status < 500) break;
      if (attempt === RETRY.length) throw new FetchFail(503, "Máy chủ đang bận, chưa tải về được. Vui lòng thử lại sau ít phút.");
    }
  }
  window.location.href = url;
}
